/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const palette = {
  purpleLight: '#8C6FF7',
  purplePrimary: '#5A31F4',
  purpleDark: '#3F22AB',
  cyan: '#acebfd',

  greenLight: '#56DCBA',
  greenPrimary: '#068a55',
  greenDark: '#0A906E',
  greenLightDark: '#3d9982',
  paleGreen: '#E4F0E1',

  black: '#0B0B0B',
  white: '#ffffff',
  grey: '#e3e6eb',
  greyDark: '#d9d9d9',
  silver: '#c3c3c3',
  'grey-2': '#606060',
  blackTransparent: 'rgba(11,11,11,0.3)',

  'blue-2': '#1a4677',
  blueSecondary: '#5987af',
  blueDark: '#88aecb',
  blueLight: '#bad5ea',
  greenSecondary: '#8cc63f',
  orangePrimary: '#e96830',
  orangeSecondary: '#d16830',
  bluePrimary: '#242c43',
  blueBCCI: '#2664f5',
  transparent: 'transparent',
};
